<script>
/* eslint-disable no-undef */
import { cloneDeep } from 'lodash-es'

export default {
    name: 'MonthlyNav',

    props: {
        bottomNav: {
            type: Boolean,
            default: false
        },
        dataSet: {
            type: Object,
            required: true
        },
        disableBorderTop: {
            type: Boolean,
            default: false
        },
    },

    computed: {
        prevMonth() {
            return cloneDeep(this.dataSet.navMonthStart).subtract(1, 'month')
        },
        nextMonth() {
            return cloneDeep(this.dataSet.navMonthStart).add(1, 'month')
        },
    },

    methods: {
        startWithinMonthOrAfter() {
            const monthStartBefore = cloneDeep(this.dataSet.navMonthStart)
            monthStartBefore.subtract(1, 'months')

            const monthEndBefore = cloneDeep(monthStartBefore)
            monthEndBefore.add(1, 'months').startOf('day')
            monthEndBefore.subtract(1, 'days').startOf('day')

            const _start = moment(this.dataSet.navDateRange.start)
            const _between = _start.isBetween(monthStartBefore, monthEndBefore, undefined, '[]')
            const _sameOrAfter = monthStartBefore.isSameOrAfter(_start)

            return _between || _sameOrAfter
        },

        endWithinMonthOrBefore() {
            const monthStartAfter = cloneDeep(this.dataSet.navMonthStart)
            monthStartAfter.add(1, 'months')

            const monthEndAfter = cloneDeep(monthStartAfter)
            monthEndAfter.add(1, 'months').startOf('day')
            monthEndAfter.subtract(1, 'days').startOf('day')

            const _end = moment(this.dataSet.navDateRange.end)
            const _between = _end.isBetween(monthStartAfter, monthEndAfter, undefined, '[]')
            const _sameOrBefore = monthEndAfter.isSameOrBefore(_end)

            return _between || _sameOrBefore
        },

        navigate(payload) {
            switch (payload) {
            case 'month-before':
                if ( this.startWithinMonthOrAfter() ) {
                    this.$emit('navigate', payload)
                }
                break
            case 'month-after':
                if ( this.endWithinMonthOrBefore() ) {
                    this.$emit('navigate', payload)
                }
                break
            default:
                console.error('unknown case in monthly nav navigate: ', payload)
            }

            this.$scrollTo(document.body)
        }
    }
}
</script>

<template>
    <div
        class="calendar-subnav d-flex py-4 position-relative"
        :class="{ 'disable-border-top' : disableBorderTop }"
    >
        <!-- MOBILE BELOW -->
        <div class="outer d-flex d-sm-none">
            <div
                class="nav-left"
                :class="{
                    'active' : startWithinMonthOrAfter()
                }"
                @click="navigate('month-before')"
            >
                <svg class="icon icon-cal-subnav-left">
                    <use xlink:href="#cal-subnav-left" />
                </svg>
            </div>
            <div class="nav-center px-sm-5 text-center text-uppercase">
                {{ dateFormatMonth(dataSet.navMonthStart) }}
            </div>
            <div
                class="nav-right"
                :class="{
                    'active' : endWithinMonthOrBefore()
                }"
                @click="navigate('month-after')"
            >
                <svg class="icon icon-cal-subnav-right">
                    <use xlink:href="#cal-subnav-right" />
                </svg>
            </div>
        </div>

        <!-- DESKTOP BELOW -->
        <div class="outer d-none d-sm-flex">
            <button
                class="month-short lighter text-uppercase no-btn"
                :class="{
                    'active' : startWithinMonthOrAfter()
                }"
                tabindex="0"
                @click="navigate('month-before')"
            >
                {{ dateFormatMonthShort(prevMonth) }}
            </button>
            <button
                class="nav-left no-btn"
                :class="{
                    'active' : startWithinMonthOrAfter()
                }"
                tabindex="0"
                @click="navigate('month-before')"
            >
                <svg class="icon icon-cal-subnav-left">
                    <use xlink:href="#cal-subnav-left" />
                </svg>
            </button>
            <div class="nav-center month-short text-center text-uppercase">
                {{ dateFormatMonthShort(dataSet.navMonthStart) }}
            </div>
            <button
                class="nav-right no-btn"
                :class="{
                    'active' : endWithinMonthOrBefore()
                }"
                tabindex="0"
                @click="navigate('month-after')"
            >
                <svg class="icon icon-cal-subnav-right">
                    <use xlink:href="#cal-subnav-right" />
                </svg>
            </button>
            <button
                class="month-short lighter text-uppercase no-btn"
                :class="{
                    'active' : endWithinMonthOrBefore()
                }"
                tabindex="0"
                @click="navigate('month-after')"
            >
                {{ dateFormatMonthShort(nextMonth) }}
            </button>
            <div class="year">
                {{ dateFormatYear(dataSet.navMonthStart) }}
            </div>
        </div>
    </div>
</template>
